import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { style } from '@vanilla-extract/css';

export const regexInputDelimiter = style([
  {
    color: themeVars.container.foreground.secondary,
  },
]);
